export const NAME = 'consultationFee';